import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

import "./AchCompanyNameInput.scss";

interface AchCompanyNameInputProps {
    achCompanyName: string;
    onSetAchCompanyName: (amount: string) => void;
    onSetIsAchCompanyNameValid: (isAmountValid: boolean) => void;
}

export const AchCompanyNameInput: React.FunctionComponent<AchCompanyNameInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAchFirstNameError = 'Company Name is a required field.';

    useEffect(() => {
        props.onSetIsAchCompanyNameValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchCompanyName(value);
        validateAchCompanyName();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAchCompanyName();
    }

    const validateAchCompanyName = () => {
        let errorsTemp: string[] = [];
        if (props.achCompanyName === '') {
            errorsTemp.push(requiredAchFirstNameError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="ach-name-container">
        <Input isValid={isValid} type='text' required={true} value={props.achCompanyName} onChange={onChange}
               onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
